<template>
  <div class="k-sidebar" :class="sidebarClasses">
    <!-- Mobile Close Button -->
    <button 
      class="k-sidebar__close"
      @click="closeMobileSidebar"
      aria-label="Sidebar schließen"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
    
    <!-- Logo -->
    <div class="k-sidebar__logo">
      <router-link to="/dashboard" class="k-sidebar__logo-link" @click.native="onLinkClick">
        <div class="k-sidebar__logo-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
          </svg>
        </div>
        <span class="k-sidebar__logo-text">{{ title }}</span>
      </router-link>
    </div>

    <!-- Navigation -->
    <nav class="k-sidebar__nav">
      <slot name="links">
        <ul class="k-sidebar__menu">
          <li
            v-for="(link, index) in sidebarLinks"
            :key="index"
            class="k-sidebar__item"
          >
            <router-link
              :to="link.path"
              class="k-sidebar__link"
              active-class="k-sidebar__link--active"
              @click.native="onLinkClick"
            >
              <span class="k-sidebar__link-icon">
                <i :class="link.icon"></i>
              </span>
              <span class="k-sidebar__link-text">
                {{ link.name }}
              </span>
            </router-link>
          </li>
        </ul>
      </slot>
    </nav>

    <!-- Footer -->
    <div class="k-sidebar__footer">
      <slot name="footer">
        <div class="k-sidebar__version">
          <span class="k-sidebar__version-text">v1.0.0</span>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
/**
 * SideBar - Apple-style sidebar navigation
 * @description Modern sidebar with mobile-friendly slide-in functionality
 * @prop {String} title - Application title
 * @prop {Array} sidebarLinks - Navigation links array
 */
export default {
  name: "SideBar",
  props: {
    title: {
      type: String,
      default: "Kemaris",
    },
    backgroundColor: {
      type: String,
      default: "vue",
    },
    activeColor: {
      type: String,
      default: "success",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
      addLink: this.addLink,
      removeLink: this.removeLink,
    };
  },
  data() {
    return {
      links: [],
    };
  },
  computed: {
    /**
     * Computed classes for sidebar
     * @returns {Object}
     */
    sidebarClasses() {
      return {
        'k-sidebar--open': this.$sidebar.showSidebar,
      };
    },
  },
  methods: {
    /**
     * Closes sidebar on mobile
     */
    closeMobileSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    /**
     * Handle link click - close sidebar on mobile
     */
    onLinkClick() {
      if (this.autoClose && window.innerWidth <= 991) {
        this.$sidebar.displaySidebar(false);
      }
    },
    /**
     * Adds a link to the links array
     * @param {Object} link - Link component
     */
    addLink(link) {
      const index = this.$slots.links
        ? this.$slots.links.indexOf(link.$vnode)
        : -1;
      if (index !== -1) {
        this.links.splice(index, 0, link);
      } else {
        this.links.push(link);
      }
    },
    /**
     * Removes a link from the links array
     * @param {Object} link - Link component
     */
    removeLink(link) {
      const index = this.links.indexOf(link);
      if (index > -1) {
        this.links.splice(index, 1);
      }
    },
  },
};
</script>
